import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import AuthLogin from "./containers/AuthLogin";
import AuthSignup from "./containers/AuthSignup";
import AuthForgotPwd from "./containers/AuthForgotPwd";
import AuthContinueSignonWithCode from "./containers/AuthContinueSignonWithCode";
import NotFound from "./containers/NotFound";
import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Styleguide from "./containers/Styleguide";
import ProdectViewer from "./containers/ProdectViewer";

export default ({ childProps }) =>
    <Switch>
        <AppliedRoute path="/" exact component={Home} props={childProps} />
        <UnauthenticatedRoute path="/authLogin" exact component={AuthLogin}  props={childProps} />
        <UnauthenticatedRoute path="/authSignup" exact component={AuthSignup} props={childProps} />
        <UnauthenticatedRoute path="/authForgotPwd" exact component={AuthForgotPwd} props={childProps} />
        <UnauthenticatedRoute path="/authContinueSignonWithCode" exact component={AuthContinueSignonWithCode} props={childProps} />
        <AuthenticatedRoute path="/styleguide" exact component={Styleguide} props={childProps} />
        <AuthenticatedRoute path="/viewer" exact component={ProdectViewer} props={childProps} />
        { /* Finally, catch all unmatched routes */ }
        <Route component={NotFound} />
    </Switch>;
